import React, { useEffect, useState } from 'react'
import { IoSettingsOutline } from 'react-icons/io5'
import { GrCheckmark, GrClose } from 'react-icons/gr'
import ProductService from '../services/ProductService'
import Select from "react-select";
import { MdAdd } from "react-icons/md";
import { toast, ToastContainer } from 'react-toastify';


const DocumentForm = (props) => {
    const [productOptions, setProductOptions] = useState([]);
    const [quantityType, setQuantityType] = useState("Quantity");
    const [rows, setRows] = useState([
        { item: "", description: "", quantity: 1, rate: "", tax: "5%", amount: "" }
    ]);
    const [errors, setErrors] = useState({});

    const handleAddItem = () => {
        console.log("Add Item");
    }
    const fetchProducts = async () => {
        try {
            const response = await ProductService.list();
            if (response.status === 200) {
                setProductOptions(response?.data?.data?.map((item) => ({
                    label: item.name,
                    value: item.id,
                })));
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
            console.log("Error in getting users.", [error]);
        }
    }
    useEffect(() => {
        fetchProducts();
    }, []);
    const handleQuantityChange = (e) => {
        setQuantityType(e.target.value);
    }
    const addRows = () => {
        if (rows.length === 0) return;

        const lastRow = rows[rows.length - 1];
        if (!lastRow.item || !lastRow.description || !lastRow.rate || !lastRow.amount) {
            setErrors({
                item: "Item is required",
                description: "Description is required",
                rate: "Rate is required",
                amount: "Amount is required"
            });
            return;
        }

        setRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows.push({
                item: "",
                description: "",
                quantity: 1,
                rate: "",
                tax: "5%",
                amount: ""
            });
            return updatedRows;
        });
        setErrors({});
    };

    const removeRows = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    }
    const handleChangeItem = async (e) => {
        const productId = e.value;
        try {
            const response = await ProductService.get(productId);
            if (response.status === 200) {
                const product = response?.data?.data;
                const newRows = [...rows];
                const lastRow = newRows[newRows.length - 1];

                lastRow.item = product.name;
                lastRow.description = product.description || "";
                lastRow.rate = product.selling_price || "";
                lastRow.amount = product.selling_price || "";

                setRows(newRows);
                setErrors({});
            }
        } catch (error) {
            console.log("Error in getting users.", [error]);
            toast.error("Error in getting users.");
        }
    }

    const handleItemChange = (e, index, field) => {
        const newRows = [...rows];
        newRows[index][field] = e.target.value;
        setRows(newRows);
    }

    return (
        <>
            {/* Input Group - 2 Columns */}
            <div className="row">
                <div className="col-xl-4">
                    <div className="input-group mt-3 d-flex align-items-center">
                        <div className="flex-grow-1">
                            <Select
                                name="item"
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable
                                placeholder="Select Product"
                                options={productOptions}
                                onChange={(e) => handleChangeItem(e)}
                            />
                        </div>
                        <button type="button" className="btn btn-white" onClick={() => handleAddItem()}>
                            <MdAdd />
                        </button>
                    </div>
                </div>

                {/* Quantity Radio Buttons */}
                <div className="col-xl-8">
                    <div className="mt-3 text-end">
                        <label className="me-2">Show quantity as:</label>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="quantity"
                                id="quantity"
                                value="Quantity"
                                checked={quantityType === "Quantity"}
                                onChange={handleQuantityChange}
                            />
                            <label className="form-check-label" htmlFor="quantity">Quantity</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="hours"
                                id="hours"
                                value="Hours"
                                checked={quantityType === "Hours"}
                                onChange={handleQuantityChange}
                            />
                            <label className="form-check-label" htmlFor="hours">Hours</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="quantity"
                                id="qty_hours"
                                value="Qty/Hours"
                                checked={quantityType === "Qty/Hours"}
                                onChange={handleQuantityChange}
                            />
                            <label className="form-check-label" htmlFor="qty_hours">Qty/Hours</label>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="row">
                <div className="table-responsive mt-3">
                    {/* Table */}
                    <table className="table table-sm estimate-items-table items table-main-estimate-edit has-calculations no-mtop">
                        <thead>
                            <tr>
                                <th width="20%" align="left">Item</th>
                                <th width="25%" align="left">Description</th>
                                <th width="10%" align="right">{quantityType}</th>
                                <th width="15%" align="right">Rate</th>
                                <th width="20%" align="right">Tax</th>
                                <th width="10%" align="right">Amount</th>
                                <th align="center"><IoSettingsOutline /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={index} id={`item-${index}`}>
                                    {/* Item Field */}
                                    <td>
                                        <textarea
                                            name="item"
                                            rows="2"
                                            className="form-control"
                                            placeholder="Item"
                                            value={row.item}
                                            onChange={(e) => handleItemChange(e, index, 'item')}
                                        />
                                    </td>

                                    {/* Description Field */}
                                    <td>
                                        <textarea
                                            name="description"
                                            rows="2"
                                            className="form-control"
                                            placeholder="Description"
                                            value={row.description}
                                            onChange={(e) => handleItemChange(e, index, 'description')}
                                        />
                                    </td>

                                    {/* Quantity Field */}
                                    <td>
                                        <input
                                            type="number"
                                            name="quantity"
                                            min="0"
                                            value={row.quantity}
                                            className="form-control"
                                            placeholder="Qty"
                                            onChange={(e) => handleItemChange(e, index, 'quantity')}
                                        />
                                    </td>

                                    {/* Rate Field */}
                                    <td>
                                        <input
                                            type="number"
                                            name="rate"
                                            placeholder="Rate"
                                            value={row.rate}
                                            className="form-control"
                                            onChange={(e) => handleItemChange(e, index, 'rate')}
                                        />
                                    </td>

                                    {/* Tax Field */}
                                    <td>
                                        <select
                                            className="form-control form-select tax"
                                            name="tax"
                                            id="tax"
                                            value={row.tax}
                                            onChange={(e) => handleItemChange(e, index, 'tax')}
                                        >
                                            <option value="5%">5%</option>
                                            <option value="10%">10%</option>
                                            <option value="15%">15%</option>
                                        </select>
                                    </td>

                                    {/* Amount Field */}
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Amount"
                                            value={row.amount}
                                            onChange={(e) => handleItemChange(e, index, 'amount')}
                                        />
                                    </td>

                                    {/* Action Button (Add or Remove) */}
                                    <td>
                                        {index === rows.length - 1 && (
                                            <button type="button" className="btn btn-primary btn-sm me-2" onClick={addRows}>
                                                <GrCheckmark />
                                            </button>
                                        )}
                                        {rows.length > 1 && (
                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => removeRows(index)}>
                                                <GrClose />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                            {Object.keys(errors).length > 0 && (
                                <tr>
                                    <td colSpan="7">
                                        <div className="alert alert-danger">
                                            <ul>
                                                {Object.values(errors).map((error, index) => (
                                                    <li key={index}>{error}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
            </div>

            <hr />
            <div className="row">
                <div className="col-md-6"></div>
                <div className="col-md-6">
                    <div className="table-responsive">
                        <table className="table table-borderless text-end mb-0">
                            <tbody>
                                <tr>
                                    <td className="w-50">Sub Total:</td>
                                    <td data-subtotal="0" className="w-50 text-secondary">INR 0.00</td>
                                </tr>
                                <tr>
                                    <td className="w-50">
                                        <div className="d-flex align-items-center gap-2">
                                            <label htmlFor="discount" className="mb-0">Discount</label>
                                            <div className="input-group">
                                                <input type="text" name="discount_value" className="form-control" defaultValue={0} />
                                                <select name="discount" id="discount" className="form-select">
                                                    <option value="fixed">Fixed</option>
                                                    <option value="percent">%</option>
                                                </select>
                                            </div>
                                        </div>
                                    </td>
                                    <td data-discount="0" className="w-50 text-secondary">INR 0.00</td>
                                </tr>
                                <tr>
                                    <td className="w-50">
                                        <div className="d-flex align-items-center gap-2">
                                            <label htmlFor="adjustment" className="mb-0">Adjustment</label>
                                            <input type="text" name="adjustment_value" className="form-control" defaultValue={0} />
                                        </div>
                                    </td>
                                    <td data-adjustment="0" className="w-50 text-secondary">INR 0.00</td>
                                </tr>
                                <tr className="border-top">
                                    <td className="w-50"><strong>Total:</strong></td>
                                    <td data-total="0" className="fs-5 w-50 text-secondary">INR 0.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default DocumentForm